import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

import HeadPhone from "../assets/headPhone.svg";

const TTSSpeaker = ({ questionText, voice_field }) => {
  const iframeRef = useRef(null);
  const [lang, setLang] = useState("en");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setLang(params.get("lang") || "en");
  }, [location.search]);

  const startSpeak = () => {
    const text = voice_field == null ? questionText : voice_field;
    playTTS(lang, text);
  };

  const playTTS = (lang, sentence) => {
    const iFrame = iframeRef.current;
    if (!iFrame) return;

    iFrame.removeAttribute("sandbox");

    const iFrameDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    const iFrameBody = iFrameDoc.body;

    const sanitizedSentence = sentence.replace(/ /g, "+").replace(/[.]/g, "");
    const link = `https://translate.google.com/translate_tts?ie=UTF-8&client=tw-ob&tl=${lang}&q=${sanitizedSentence}`;

    iFrameBody.innerHTML = `<audio src="${link}" id="TTS" autoplay></audio>`;

    iFrame.setAttribute("sandbox", ""); // re-isolate
  };

  const isArabic = lang === "ar";

  return (
    <div className={`float-${isArabic ? "left" : "right"}`}>
      <img
        src={HeadPhone}
        onClick={(e) => {
          e.preventDefault();
          startSpeak();
        }}
        className="h-9 w-9 cursor-pointer"
        alt="phone"
      />

      <iframe id="ttsiframe" ref={iframeRef} hidden title="TTS Iframe" />
    </div>
  );
};

export default TTSSpeaker;
